import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { ThemeProvider } from "./contexts/ThemeContext";
const rootEl = document.getElementById("root");
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<ThemeProvider data-id="element-199" data-mp="21cagg7x1ibhd">
      <App data-id="element-200" data-mp="269alcfi5l86w" />
    </ThemeProvider>);
}